/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PlatformAdminUIState, PlatformAdminUIThunkType } from '../../store/store';
import GeoAreasListView from './GeoAreasList.view';
import { RouteComponentProps } from 'react-router-dom';
import { ClientCommunity, ClientGeoAreaExtended } from '@DigitaleDoerfer/digitale-doerfer-api';
import { getGeoAreas } from '../../store/Global.actions';
import { GlobalActionTypes } from '../../store/GlobalActionTypes';

interface GeoAreaRouteParams {
	searchText?: string;
}

interface Props extends RouteComponentProps<GeoAreaRouteParams> {
	geoAreas: ClientGeoAreaExtended[];
	loading: boolean;
	tenants: ClientCommunity[];
	getGeoAreas: () => void;
}

class GeoAreasListContainer extends Component<Props> {
	componentDidMount(): void {
		const { geoAreas, getGeoAreas } = this.props;
		if (geoAreas.length === 0) {
			getGeoAreas();
		}
	}

	render(): JSX.Element {
		const { geoAreas, loading, getGeoAreas, tenants, match } = this.props;
		const initialFilterText = match.params.searchText;
		return (
			<GeoAreasListView
				tenants={tenants}
				geoAreas={geoAreas}
				loading={loading}
				getGeoAreas={getGeoAreas}
				initialFilterText={initialFilterText}
			/>
		);
	}
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (state: PlatformAdminUIState) => {
	return {
		loading: state.global.geoAreasData.loading,
		geoAreas: state.global.geoAreasData.geoAreas,
		tenants: state.global.tenants
	};
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapDispatchToProps = (dispatch: PlatformAdminUIThunkType<GlobalActionTypes>) => {
	return {
		getGeoAreas: (): Promise<void> => dispatch(getGeoAreas())
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(GeoAreasListContainer);
